import { ISearchPriceDetail } from '../../../quote-request/-components/ignore/imports/form'
import { IDataCooperator } from '~/pages/trucker-[id]/partner/-components/imports/form'

export interface addQuote {
  _id?: string
  cooperatorDetail: IDataCooperator | null
  contactDetail: { [key: string]: any } | null
  quoteRequest?: string
  prices?: Array<ISearchPriceDetail>
  informationEditorPricingSelling: {
    tempPricingRequest: number | null // giá bán đề nghị
    pricingRequest: number | null // giá bán
    commission: number | null
    duration: number | null
    priceIncrementLevel: number | null
  }
  workflow: string
  positions: Array<{ [key: string]: any }>
  transportation: string
  mergeContainer: boolean
  headContainer: boolean
  contCategory?: number | null
  vehicleCategory?: string | null
  vehicleCategoryName?: string | null
  productivity?: number | null
  weightCommodity?: number | null
  customerName: string
  customer: string
  contact: string
  contactName: string
  contactPhone?: string
  contactEmail?: string
  priceOfflineFee?: Array<ISearchPriceDetail>
  oldPriceOfflineFee?: Array<ISearchPriceDetail>
  policy: {
    freeHourNumber: number
    moocKeepHourly: number
    moocKeepOvernight: number
    calculatedByHourNextDay?: string
    moocKeepLongTerm: number
    calculatedFromEvening: number
    towingContainerSunday: number
    towingContainerHoliday: number
    reeferPluginChargesGenerator: number
  }
  priceGasOline?: number
  typeCommodity?: string
  goodType?: string
  typeDangerous?: string
  typeFragileGoods?: string
  typeReefer?: string
  contName?: string
  status: number
  dataConfig?: {
    duration: number
    commission: number
    corporateIncomeTax: number
    monthlyInterest: number
    priceGasOline: number
    incrementLevel: number
    markup: number
  }
  customerService: {
    id: string
    name: string
    phone: string
  }
  abstemious: {
    id: string
    name: string
    phone: string
  }
  groupEmail: string
  compensationCost: number | null
  exceptCompensationCost: string
  quoteRequestId?: string
  charges: Array<ISearchPriceDetail>
  quoteTempSaveId: string
  effectiveFromDate: string
  effectiveToDate: string
  statusApprovalMarkup: number | null
  minMarkupConfirm: number | null
  markupAvailable: boolean
  quoteRequestDetail?: { [key: string]: any }
  quoteTempSave?: { [key: string]: any }
  comfirmRouteGGMap?: boolean
}
export default {}
